<template>
    <div v-if="ready" class="mt-3">
        <h5 class="mb-3">Décisions AG — Commissaires aux comptes</h5>
        <b-form-checkbox
            v-model="form.cac_renewed"
            switch
            class="mb-2"
            @change="updateSwitch('cac_renewed')"
        >
            {{ labels.cac_renewed }}
        </b-form-checkbox>
        <b-form-checkbox
            v-model="form.cac_replaced"
            switch
            class="mb-2"
            @change="updateSwitch('cac_replaced')"
        >
            {{ labels.cac_replaced }}
        </b-form-checkbox>
        <b-form-checkbox
            v-model="form.cac_substitue_renew"
            switch
            class="mb-2"
            @change="updateSwitch('cac_substitue_renew')"
        >
            {{ labels.cac_substitue_renew }}
        </b-form-checkbox>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import ToastHandler from '../../../../common/mixins/ToastHandler.vue'

export default {
    name: 'CacMandateSwitches',

    mixins: [ToastHandler],

    data() {
        return {
            ready: false,
            labels: {
                cac_renewed: '',
                cac_replaced: '',
                cac_substitue_renew: '',
            },
            form: {
                cac_renewed: false,
                cac_replaced: false,
                cac_substitue_renew: false,
            },
        }
    },

    computed: {
        ...mapState({
            client: (state) => state.legalVM.client,
            year: (state) => state.browsing.year,
        }),

        exerciseYear() {
            const y = this.year ?? new Date().getFullYear()

            return y - 1
        },
    },

    async created() {
        await this.loadKeyFigures()
    },

    methods: {
        async loadKeyFigures() {
            try {
                const response = await axios.get(
                    `/legal/clients/${this.client.id}/keyFigures/${this.exerciseYear}`
                )
                const cur = response.data?.data?.current_exercise || {}
                const extendedLabels =
                    response.data?.meta?.extended_data_labels || {}

                this.labels = {
                    cac_renewed: extendedLabels.cac_renewed || '',
                    cac_replaced: extendedLabels.cac_replaced || '',
                    cac_substitue_renew: extendedLabels.cac_substitue_renew || '',
                }
                this.form.cac_renewed = !!cur.cac_renewed
                this.form.cac_replaced = !!cur.cac_replaced
                this.form.cac_substitue_renew = !!cur.cac_substitue_renew
                this.ready = true
            } catch (error) {
                console.error(error)
            }
        },

        async updateSwitch(field) {
            this.showRecordingToast()
            try {
                await axios.put(
                    `/legal/clients/${this.client.id}/keyFigures/${this.exerciseYear}/extended-data`,
                    {
                        [field]: !!this.form[field],
                    }
                )
                await this.loadKeyFigures()
                this.handleSuccess('Valeur enregistrée')
            } catch (error) {
                this.handleErrors(error?.response?.status)
                await this.loadKeyFigures()
            }
        },
    },
}
</script>
